import type { PastSymptomData } from "@qendo/medical/past_symptom";
import { MedicalType } from "@qendo/medical/types";
import type { DateArg } from "date-fns";
import Data from "~/util/data";

export class PastSymptom extends Data implements PastSymptomData {
    public readonly type = MedicalType.past_symptom;

    constructor(
        public id?: string,
        public description: string | null = null,
        public option_id: string | null = null,
        public photograph_ids: string[] = [],
        public occurred_on: string | DateArg<Date> | null = null,
    ) {
        super();
    }
}
